import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, Subject } from "rxjs";
import {environment} from '../../environments/environment';
import { K5RevertMessageModel } from "../models/k5RevertMessage.model";

@Injectable({
    providedIn: 'root'
  })
  export class RevertAdjustmentService {
    postId;
    errorMessage;
    private revertresponse: K5RevertMessageModel;
        
    private readonly revertResultsProperty = 'k5RevertMessage';
    private REVERT_SVC_URL = environment.REVERT_SVC_URL;

    private revertItemsSubject: Subject<any[]>;
    revertItemsObservable: Observable<any[]>;

    constructor(private httpClient: HttpClient) {
        this.revertItemsSubject = new Subject<any[]>();
        this.revertItemsObservable = this.revertItemsSubject.asObservable();
    }

    postRevertAdjustmentData(auditId: number, studentAccountId: number, studentSchoolId: number, studentIdentityId: number) {
      this.sendPostRequest(auditId, studentAccountId, studentSchoolId, studentIdentityId).subscribe((
        (data: any) => {
          console.log(data['errors']);
          if((data['errors']).length != 0) {
              return data['errors'];
          } else {
            this.revertresponse = data[this.revertResultsProperty];
            this.revertItemsSubject.next(data[this.revertResultsProperty]);
            console.log(data);
            console.log(this.revertresponse);
          }
        }
    ));
    return this.revertresponse;
    }

    sendPostRequest(auditId: number, studentAccountId: number, studentSchoolId: number, studentIdentityId: number) {
      return       this.httpClient.post<any>(this.REVERT_SVC_URL, { auditId: auditId, studentAccountId: studentAccountId, studentSchoolId: studentSchoolId,
        studentIdentityId: studentIdentityId });
    }
  }

